<template>
  <div v-if="deliveryOption" class="section-summary-row">
    <span>{{ title }}</span>
    <span class="body-text">
        <span class="icon logo-rituals"></span>
        <span>
            <b>{{ deliveryOption.name }}</b><br>
            <span v-html="deliveryOption.description"></span>
        </span>
    </span>
    <span class="store-distance"> {{ deliveryOption.distance }}</span>
  </div>
</template>
<script src="./click-and-collect-summary.js"/>
